// Per-IRIS-stage recommended recheck cadence.
// Returns { targetDays, minDays, maxDays, label }
export function recheckCadence(stage) {
  return (
    {
      1: { targetDays: 270, minDays: 180, maxDays: 365, label: "every 6 to 12 months" },
      2: { targetDays: 120, minDays: 90, maxDays: 180, label: "every 3 to 6 months" },
      3: { targetDays: 60, minDays: 30, maxDays: 90, label: "every 1 to 3 months" },
      4: { targetDays: 21, minDays: 14, maxDays: 28, label: "every 2 to 4 weeks" },
    }[stage] || null
  );
}

export function daysBetween(iso1, iso2) {
  const d1 = new Date(iso1);
  const d2 = new Date(iso2);
  return Math.round((d2 - d1) / (1000 * 60 * 60 * 24));
}

export function addDays(iso, days) {
  const d = new Date(iso);
  d.setDate(d.getDate() + days);
  return d.toISOString().slice(0, 10);
}

// Assess reminder status for a cat given latest lab date + stage.
// status: 'due-soon' | 'due' | 'overdue' | 'on-track'
export function recheckStatus(latestLabDate, stage) {
  const cad = recheckCadence(stage);
  if (!cad || !latestLabDate) return null;
  const today = new Date().toISOString().slice(0, 10);
  const dueDate = addDays(latestLabDate, cad.targetDays);
  const daysUntilDue = daysBetween(today, dueDate);
  const daysSinceLast = daysBetween(latestLabDate, today);
  let status = "on-track";
  if (daysSinceLast > cad.maxDays) status = "overdue";
  else if (daysSinceLast >= cad.targetDays) status = "due";
  else if (daysUntilDue <= 14) status = "due-soon";
  return {
    status,
    dueDate,
    daysUntilDue,
    daysSinceLast,
    cadenceLabel: cad.label,
  };
}
